//MUI IMPORTS
import React, {
  useState, useEffect, useRef
} from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  ThemeProvider,
  createTheme,
} from "@mui/material"
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CustomBackdrop from "../../CustomBackdrop";

//CUSTOM IMPORTS
import FormDatosFact from "./FormDatosFact";
import TablaItems from "./TablaItems";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import PreFactura from "./PreFactura";
import { getData } from "../../../services/library"
import * as helpers from "./helpers"
import * as api from "./api"
import { v4 as uuidv4 } from "uuid";


function AddComprobante(props) {
  const [opReference, setOpReference]=useState();

  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  const [permisos, setPermisos] = useState();
  // const [sucTieneAlias, setSucTieneAlias] = useState(false); //esta variable guardara si la sucursal del usuario tiene registrado un alias o no. NECESARIO PORQUE EL "ALIAS" EN OTRO SISTEMA, ES UNA COLUMNA QUE SE UTILIZA PARA GUARDAR EL ALIAS DE LA MISMA SUCURSAL EN OTRO SISTEMA (UTILIZADO EN FACTURACION). POR LO TANTO, SI TIENE ALIAS REGISTRADO EN ESTA COLUMNA, INDICA QUE LA SUCURSAL TAMBIEN FACTURA EN OTRO SISTEMA, O SEA, PARA OTRA EMPRESA. POR LO TANTO SI "SUCTIENEALIAS" ES VERDADERO, ENTONCES DEBEREMOS HABILITAR LAS OTRAS EMPRESAS. Ejemplo: Pta Córdoba. En Hiper es 17 y en Auto es 73. En dicha sucursal se factura para las dos empresas.
  const [dataCliente, setDataCliente] = useState(props.dataCliente || null);
  const [dataDireccion, setDataDireccion] = useState();
  const [anulacionCompleta, setAnulacionCompleta] = useState(false);
  const [anulacionParcial, setAnulacionParcial] = useState(false);
  const [comprobanteAsociado, setComprobanteAsociado] = useState();
  const [tipoCbtePosible, setTipoCbtePosible] = useState();

  const [items, setItems] = useState([{
    cantidad: "",
    unidadMedida: "",
    descUnidadMedida: "",
    precioUnitario: "",
    totalItem: "",
    idProducto: null,
    stockeable:true
  }])
  const [paramsNegocios, setParamsNegocios] = useState(); //parametros que contienen donde tengo que ir a buscar los datos segun el negocio del cliente (granel, envasado, etc).
  const [regPrefactura, setRegPrefactura] = useState({});
  const [impNeto, setImpNeto] = useState();
  const [regPrecio, setRegPrecio] = useState();
  const [um, setUM] = useState(); // Unidades de medida
  const [tipoComprobante, setTipoComprobante] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [userSucData, setUserSucData]=useState();
  const [formData, setFormData] = useState({ tipoCompGen: 1, sucEmisora: "", empEmisora: "" });
  const [productos, setProductos] = useState([]);

  const localStorageData = {
    username: localStorage.getItem("user"),
    idSucUser: parseInt(localStorage.getItem("sucursal")),
    idsSucAuth: localStorage.getItem("suc_auth")
  }

  //Manejan componentes visuales
  const [showPreFactura, setShowPreFactura] = useState(false);
  const contentRef = useRef(null); 
  const [disBtn, setDisBtn] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCheckConsFinal, setShowCheckConsFinal] = useState(true);
  const [leyenda, setLeyenda]=useState("");

  /* --------------------------- HANDLERS --------------------------------  */
  const handleSubmit = async () => {

    setDisBtn(true)
    setLoading(true)
    const enviar = {
      ...formData,
      usuarioEmite: localStorage.getItem("user"),
      idNegocioCliente: dataCliente.id_negocio_cliente,
      idCliente: dataCliente.id,
      idDireccion: dataDireccion?.id,
      netoFront: parseFloat(impNeto.toFixed(2)),
      idPedidoRemito: formData.idPedidoRemito || null,
      renglones: items.map((item) => {
        const campo = um.filter((um) => um.id === item.unidadMedida)[0].campo;
        return ({
          ...item,
          detalle: item.descripcion,
          cantidad: parseFloat(item.cantidad),
          precioUnitario: parseFloat(item.precioUnitario),
          stockeable:Number(item.stockeable),
          ...(campo ? { [campo]: parseFloat(item.precioUnitario) } : {}) //precio lt o kg sin iva (si mando kgs, calculo el lt y si mando lt, calculo el kg)
        })
      }),
      comprobanteAsociado: comprobanteAsociado,
      anulacionCompleta,
      leyendaManual:leyenda,
      calcularIIBBCorrectos:permisos["ver_actualizaciones"] || false,
      origen:4,
      opReference:opReference || null
    }

    try {
      const res = await fetch(
        `${UrlApi}/prefacturas/arma_prefactura`
        , {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(enviar),
        }
      )
      if (res.ok) {
        const data = await res.json();
        if (!!data) {
          const respuesta = await fetch(UrlApi + "/prefacturas/" + data.id)
          const prefac = await respuesta.json();
          setRegPrefactura(prefac)
          if (!!prefac.data) {
            setShowPreFactura(true)
          }
        }
      } else {
        const error = await res.json();
        alert(`${error.error}. ${error.detalle || ''} ` || "Error")
      }
    } catch (error) {
      console.log("CATCH", error)
      console.log(error)
      alert(error)
    }
    finally {
      setLoading(false)
      setDisBtn(false)
    }
  }

  /* --------------------------- HELPERS (Calculan o deciden algo) --------------------------------  */
  const deshabilitarGuardar = () => {
    if (!!formData.tipoCompGen && !!formData.sucEmisora && !!formData.empEmisora && !!dataCliente) {
      return items.some((i) => !i.cantidad || !i.unidadMedida || !i.precioUnitario || !i.idProducto)
    }
    return true;
  }

  const getSucEmpresa = (empresa) => {
    getData(`/sucursales/xempxauthxfacturacion/${empresa}/${localStorageData.idsSucAuth}`, setSucursales)
  }

  const limpiarItems = () => {
    setItems([
      {
        cantidad: "",
        unidadMedida: "",
        descUnidadMedida: "",
        precioUnitario: "",
        totalItem: "",
        idProducto: null,
        stockeable:true
      }])
    setComprobanteAsociado(null)
    setAnulacionCompleta(null)
  }

  /* --------------------------- EFFECTS --------------------------------  */

  useEffect(() => {
    setOpReference(uuidv4())
    let usos = [249, 250]
    logEventos(
      "Acceso al menú facturacion",
      "Ventas",
      "Nuevo Comprobante",
      localStorage.getItem("user"));
    api.getUnidadesMedida(setUM);
    api.obtenerProductos(usos, setProductos);
    getData("/tipos_comprobantes_generico", setTipoComprobante);
    getData("/parametrosPorNegocio", setParamsNegocios);
    helpers.definirPermisos(setPermisos);
    helpers.setDatosPorDefecto(
      localStorageData.idSucUser, 
      setFormData, 
      setEmpresas, 
      setSucursales, 
      // setSucTieneAlias, 
      setUserSucData
    );
  }, []);

  useEffect(() => {
    if (dataCliente && dataDireccion) {
      //aca abajo hago todo esto porque para setear los datos por defecto necesito empresas y sucursales, por lo tanto, ya que voy a buscar dichos datos, los seteo.
      Boolean(props?.predeterminar) && helpers.predeterminarLinea(dataCliente, dataDireccion, paramsNegocios, setRegPrecio, setItems);
    }
  }, [dataCliente, dataDireccion])

  useEffect(() => {
    if (items?.length > 1 && contentRef.current) {
      setTimeout(() => {
        contentRef.current.scrollTo({
          top: contentRef.current.scrollHeight,
          behavior: "smooth",
        })
      }, 100)
    }
  }, [items?.length])

  /* --------------------------- STYLING --------------------------------  */
  const theme = createTheme({
    palette: {
      primary: {
        main: "#164e63",
      },
      secondary: {
        main: "#475569",
      },
      light: {
        main: "#f1f5f9",
      }
    }
  })


  useEffect(() => {
    if (tipoComprobante.length && formData.tipoCompGen) {
      const params = JSON.parse(tipoComprobante.find(tipo => tipo.id_tipo_comprobante_generico == formData.tipoCompGen).params)
      setDisBtn(params?.seleccionar_factura && !comprobanteAsociado)
      const usos = (params?.id_uso_posible).split(",").map(num => Number(num));
      api.obtenerProductos(usos, setProductos)
    }
  }, [formData])

  /* --------------------------- RENDER --------------------------------  */
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            height: "calc(100vh - 64px)",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#f0f0f0",
          }}
        >
          <Box
            ref={contentRef}
            sx={{
              flex: 1,
              overflowY: 'auto',
              p: 2,
              pb: "135px"
            }}
          >
            <FormDatosFact
              props={props.dataCliente} //Esto solamente me sirve para indicar que ya tengo el cliente predefinido, ya que es el que me voy pasando como propiedad. A diferencia de "dataCliente", que puede ser el que me viene como propiedad o el que elijo. 
              formData={formData}
              setFormData={setFormData}
              dataCliente={dataCliente}
              setDataCliente={setDataCliente}
              dataDireccion={dataDireccion}
              setDataDireccion={setDataDireccion}
              setItems={setItems}
              permisos={permisos}
              sucursales={sucursales}
              tipoComprobante={tipoComprobante}
              empresas={empresas}
              showCheckConsFinal={showCheckConsFinal}
              setShowCheckConsFinal={setShowCheckConsFinal}
              getSucEmpresa={getSucEmpresa}
              paramsNegocios={paramsNegocios}
              comprobanteAsociado={comprobanteAsociado}
              setComprobanteAsociado={setComprobanteAsociado}
              anulacionCompleta={anulacionCompleta}
              anulacionParcial={anulacionParcial}
              setAnulacionParcial={setAnulacionParcial}
              setAnulacionCompleta={setAnulacionCompleta}
              limpiarItems={limpiarItems}
              tipoCbtePosible={tipoCbtePosible}
              setTipoCbtePosible={setTipoCbtePosible}
              userSucData={userSucData}
            />
            <TablaItems
              formData={formData}
              setFormData={setFormData}
              items={items}
              setItems={setItems}
              setImpNeto={setImpNeto}
              regPrecio={regPrecio}
              existeCliente={!!dataCliente}
              um={um}
              hayRemito={!!formData.idPedidoRemito}
              productos={productos}
              anulacionCompleta={anulacionCompleta}
              leyenda={leyenda}
              setLeyenda={setLeyenda}
            />
          </Box>
          <Container maxWidth="xl">
            <Card
              sx={{
                position: 'fixed',
                bottom: 16,
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #475569 0%, #334155 100%)',
                color: 'white',
                borderRadius: 3,
                overflow: 'hidden',
                zIndex: 1200,
                boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
                minWidth: 400,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateX(-50%) scale(1.02)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.4)'
                }
              }}
            >
              <CardContent sx={{ p: 2, px: 4 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 3
                  }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255,255,255,0.7)',
                        mb: 1,
                        fontFamily: '"DM Sans", sans-serif',
                        fontSize: 18
                      }}
                    >
                      Importe Neto:
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        fontFamily: '"Space Grotesk", sans-serif',
                        color: '#ffffff'
                      }}
                    >
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS"
                      }).format(impNeto || 0)}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<RemoveRedEyeIcon />}
                    sx={{
                      backgroundColor: '#0891b2',
                      '&:hover': {
                        backgroundColor: '#0e7490',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 25px rgba(8, 145, 178, 0.3)'
                      },
                      px: 3,
                      py: 2,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      borderRadius: 2,
                      fontFamily: '"DM Sans", sans-serif',
                      transition: 'all 0.3s ease',
                      textTransform: 'none'
                    }}
                    onClick={handleSubmit}
                    disabled={deshabilitarGuardar() || disBtn}
                  >
                    Previsualizar
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Container>
          <CustomBackdrop
            open={loading}
            text="Generando prefactura..."
          />
          {showPreFactura &&
            <PreFactura
              openPrefactura={showPreFactura}
              setOpenPrefactura={setShowPreFactura}
              regPrefactura={regPrefactura}
              tipoComp={formData.tipoCompGen}
              closeNewInvoiceDialog={props.closeNewInvoiceDialog}
              closePrefactura={() => setShowPreFactura(false)}
            />
          }
        </Box>
      </ThemeProvider>
    </div>
  );
}
export default AddComprobante;
